<template>
  <div id="security-question-form">
    <div class="row">
      <div class="security-question-section materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">
          <el-select  placeholder="Select a Question" id="security-question" name="security-question"
              :value="value.id"
              data-vv-name="security-question"
              :data-vv-scope="validationScope"
              v-validate="'required'"
              aria-invalid="errors.has(validationScope + '.security-question')"
              v-on:input="event => setSecurityQuestionId(event)">
            <el-option
              popper-class="select-top"
              v-for="securityQuestion in securityQuestionCatalog"
              :key="securityQuestion.id"
              :label="securityQuestion.question"
              :value="securityQuestion.id">
            </el-option>
          </el-select>
          <label for="security-question">Security Question</label>
          <span v-show="errors.has(validationScope + '.security-question')" class="help form-errors">
            {{ errors.first(validationScope + '.security-question')}}
          </span>
        </div>
      </div>

      <div class="security-question-section materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">
          <input type="text" class="form-control" id="security-answer"
                 name="security-answer"
                 data-vv-name="security-answer"
                 :data-vv-scope="validationScope"
                 v-validate="'required'"
                 aria-invalid="errors.has(validationScope + '.security-answer')"
                 ref="security-answer"
                 v-on:input="event => setSecurityAnswer(event.target.value)"
                 :value="value.answer"
                 placeholder="Answer"/>
          <label for="security-answer">Answer</label>
          <span v-show="errors.has(validationScope + '.security-answer')" class="help form-errors">
            {{ errors.first(validationScope + '.security-answer') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'security-question-form',
    inject: ['$validator'],
    props: {
      securityQuestionCatalog: Array,
      validationScope: {
        type: String,
        default: 'securityQuestionValidation'
      },
      value: {
        type: Object,
        default: function () {
          return {
            id: '',
            question: '',
            answer: ''
          }
        }
      }
    },
    methods: {
      setSecurityQuestionId (id) {
        let valueCopy = _.cloneDeep(this.value)
        valueCopy.id = id
        valueCopy.question = this.getSecurityQuestionText(id)
        this.$emit('input', valueCopy)
      },

      setSecurityAnswer (answer) {
        let valueCopy = _.cloneDeep(this.value)
        valueCopy.answer = answer
        this.$emit('input', valueCopy)
      },

      getSecurityQuestionText (id) {
        let questionText = this.securityQuestionCatalog.find((q) => {
          if (q.id === id.toString()) {
            return q.question
          } else {
            return ''
          }
        })

        questionText = (typeof (questionText) === 'object') ? questionText.question : questionText

        return questionText
      }
    }
  }
</script>

<style lang="scss">
@import '~my-account-common-css/stylesheets/materialized.scss';
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';
  @import '~my-account-common-css/stylesheets/container.scss';
  @import '~element-ui/lib/theme-default/index.css';

  #security-question-form {
    margin: 20px 0px 20px 0px;
  }

  .security-question-section {
    margin-top: 5px;
    span {
      display: block;
    }
  }

  .el-select-dropdown {

    @media (max-width: $screen-sm-min - 1px) {
      
      max-width: 95%;
      left: 2.5%;

      .el-select-dropdown__item {

        white-space: pre-line;
        text-overflow: unset;
        height: auto;
        max-height: 60px;

      }

    }

  }

  .el-select {
    width: 100%;
    .el-input__inner {
      box-shadow: none;
      border-top-width: 0;
      border-left-width: 0;
      border-right-width: 0;
      border-color: #adadad;
      border-radius: 0;
      font-size: 1.143em;
      color: #4d4e53;
      &:hover, &:focus {
        border-color: #adadad;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SecurityQuestionForm.vue